/**
 * Circle thickness patch for @tarikjabiri/dxf v2.8.9.
 *
 * set `circle.thickness = someNumber` for it to take effect.
 *
 */
import { Circle } from '@tarikjabiri/dxf'

const PATCH_FLAG = '__dxf_circle_thickness_patched__'

function applyPatch(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const proto: any = Circle.prototype

  if (proto[PATCH_FLAG]) return
  proto[PATCH_FLAG] = true

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const original: any = proto.dxfyChild

  proto.dxfyChild = function (this: any, dx: any) {
    original.call(this, dx)
    if (
      Object.prototype.hasOwnProperty.call(this, 'thickness') &&
      typeof this.thickness === 'number' &&
      Number.isFinite(this.thickness)
    ) {
      dx.push(39, this.thickness)
    }
  }
}

applyPatch()
